import { formatInTimeZone } from 'date-fns-tz';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import format from 'date-fns/fp/format';
import isToday from 'date-fns/isToday';

export const dateFormats = {
  isoDate: 'yyyy-MM-dd',
  time: 'HH:mm',
  longDate: 'EEE d MMM yyyy',
  normalDate: 'd MMM yyyy',
  // E.g. 9th Oct
  shortDate: 'd MMM',
};

/**
 * E.g. 21:30 Mon 9 Oct 2019
 */
export const formatLongWithTime = format('HH:mm EEE d MMM yyyy');

/**
 * E.g. Mon 9 Oct 2019
 */
export const formatLong = format('EEE d MMM yyyy');

/**
 * E.g. 9 Oct 2019
 */
export const formatNormal = format('d MMM yyyy');

/**
 * E.g. 21:30
 */
export const formatTime = format(dateFormats.time);

/**
 * E.g. 2019-04-21
 */
export const formatAsIsoDate = format(dateFormats.isoDate);

/**
 * Formats a date depending on whether it's today or not
 *
 * @param d Date
 * @returns
 */
export const formatNearbyDate = (d: Date, timeZone: string) =>
  isToday(d)
    ? formatDistanceToNow(d, { addSuffix: true })
    : formatInTimeZone(d, timeZone, dateFormats.longDate);
